import React from "react";
import classes from "./ConnectWithTeam.module.scss";
import CustomImage from "../../CustomImage";
import Mail from "../../UI/Icons/Mail";
import Whatsapp from "../../UI/Icons/Whatsapp";
import PhoneDarker from "../../UI/Icons/PhoneDarker";

interface ConnectWithTeamProfileImg {
  url: string;
  alternativeText?: string;
}

interface ConnectWithTeamMember {
  id: number;
  name: string;
  designation: string;
  number: string;
  email: string;
  whatsappLink?: string | null;
  profileImg?: ConnectWithTeamProfileImg;
}

interface ConnectWithTeamData {
  id: number;
  title: string;
  teamMember: ConnectWithTeamMember[];
}

interface Props {
  connectWithTeamData?: ConnectWithTeamData;
}

const getWhatsappHref = (member: ConnectWithTeamMember): string => {
  if (member.whatsappLink) return member.whatsappLink;
  return `https://wa.me/${member.number.replace(/\D/g, "")}`;
};

const ConnectWithTeam = ({ connectWithTeamData }: Props) => {
  if (!connectWithTeamData) return null;

  const { title, teamMember } = connectWithTeamData;

  return (
    <section className={classes["connect-with-team-container"]}>
      {title && <h2 className={classes.heading}>{title}</h2>}

      <div className={classes["team-row"]}>
        {teamMember?.length > 0 &&
          teamMember?.map((member) => (
            <div key={member.id} className={classes.card}>
              <div className={classes["avatar-ring"]}>
                {member.profileImg?.url && (
                  <CustomImage
                    src={member.profileImg.url}
                    alt={member.profileImg.alternativeText || member.name}
                    width={120}
                    height={120}
                    objectFit="cover"
                    className={classes.avatar}
                  />
                )}
              </div>

              <div className={classes['person-info-container']}>
                {member.name && <h3 className={classes.name}>{member.name}</h3>}
                {member.designation && <div className={classes.designation} dangerouslySetInnerHTML={{ __html: member.designation }} />}

                {member.number && (
                  <a className={classes["contact-row"]} href={`tel:${member.number}`}>
                    <PhoneDarker width={14} height={14} color="#226CF5" />
                    <span>{member.number}</span>
                  </a>
                )}

                <a className={classes["contact-row"]} href={`mailto:${member.email}`}>
                  <Mail width={14} height={14} color="#226CF5" />
                  <span>{member.email}</span>
                </a>
              </div>

              <a className={classes["whatsapp-button"]} href={getWhatsappHref(member)} target="_blank" rel="noopener noreferrer">
                <Whatsapp width={18} height={18} color="#ffffff" />
                Whatsapp
              </a>
            </div>
          ))}
      </div>
    </section>
  );
};

export default ConnectWithTeam;
